import store from '@/store/index.js'
import axios from 'axios'
import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
Vue.use(VueAxios, axios)

const routes = [
  {
    path: '/',
    redirect: '/signin',
  },
  {
    path: '/signin',
    name: 'signin',
    meta: {
      allowRoles: ['All'],
      requireAuth: false,
    },
    component: () => import('../views/login/sign-in.vue'),
  },
  {
    path: '/calendar',
    name: 'ปฏิทิน',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal'],
      requireAuth: true,
    },
    component: () => import('../views/calendar/calendar.vue'),
  },
  {
    path: '/calendar-history',
    name: 'ประวัติปฏิทิน',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal'],
      requireAuth: true,
    },
    component: () => import('../views/calendar/calendar-history.vue'),
  },
  {
    path: '/guests',
    name: 'Guest',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester'],
      requireAuth: true,
    },
    component: () => import('../views/guest/index.vue'),
  },
  {
    path: '/users',
    name: 'All Users',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal'],
      requireAuth: true,
    },
    component: () => import('../views/users/users.vue'),
  },
  {
    path: '/fortune-telling',
    name: 'ดูดวง',
    meta: {
      allowRoles: ['owner', 'admin'],
      requireAuth: true,
    },
    component: () => import('../views/fortune-telling.vue'),
  },
  {
    path: '/ai-demo',
    name: 'AI Demo',
    meta: {
      allowRoles: ['owner', 'admin'],
      requireAuth: true,
    },
    component: () => import('../views/ai-demo.vue'),
  },
  {
    path: '/auspicious',
    name: 'ดูฤกษ์',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'date-selector'],
      requireAuth: true,
    },
    component: () => import('../views/date-selection/index.vue'),
  },
  {
    path: '/auspicious/date-selection/request',
    name: 'คำร้องขอดูฤกษ์',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'date-selector'],
      requireAuth: true,
    },
    component: () => import('../views/date-selection/request.vue'),
  },
  {
    path: '/auspicious/date-selection/auspicious-selection',
    name: 'Auspicious Selection',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'date-selector'],
      requireAuth: true,
    },
    component: () => import('../views/date-selection/auspicious-selection.vue'),
  },
  {
    path: '/auspicious2',
    name: 'ดูฤกษ์2',
    meta: {
      allowRoles: [
        'owner',
        'admin',
        'tester-internal',
        'tester',
        'date-selector',
      ],
      requireAuth: true,
      aliasName: 'ดูฤกษ์',
    },
    component: () => import('../views/date-selection2/index.vue'),
  },
  {
    path: '/auspicious2/date-selection/request',
    name: 'คำร้องขอดูฤกษ์2',
    meta: {
      allowRoles: [
        'owner',
        'admin',
        'tester-internal',
        'tester',
        'date-selector',
      ],
      requireAuth: true,
      aliasName: 'คำร้องขอดูฤกษ์',
    },
    component: () => import('../views/date-selection2/request.vue'),
  },
  {
    path: '/auspicious2/date-selection/candidate-selection',
    name: 'Candidate Selection2',
    meta: {
      allowRoles: [
        'owner',
        'admin',
        'tester-internal',
        'tester',
        'date-selector',
      ],
      requireAuth: true,
      aliasName: 'Candidate Selection',
    },
    component: () => import('../views/date-selection2/candidate-selection.vue'),
  },
  {
    path: '/auspicious2/date-selection/auspicious-selection',
    name: 'Auspicious Selection2',
    meta: {
      allowRoles: [
        'owner',
        'admin',
        'tester-internal',
        'tester',
        'date-selector',
      ],
      requireAuth: true,
      aliasName: 'Auspicious Selection',
    },
    component: () =>
      import('../views/date-selection2/auspicious-selection.vue'),
  },
  {
    path: '/auspicious2/date-selection/:id',
    name: 'Date Selection',
    meta: {
      allowRoles: [
        'owner',
        'admin',
        'tester-internal',
        'tester',
        'date-selector',
      ],
      requireAuth: true,
    },
    component: () => import('../views/date-selection2/details.vue'),
  },
  {
    path: '/content',
    name: 'บทความ',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'content-writer'],
      requireAuth: true,
    },
    component: () => import('../views/content/content.vue'),
  },
  {
    path: '/content/add',
    name: 'เพิ่มบทความ',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'content-writer'],
      requireAuth: true,
    },
    component: () => import('../views/content/edit-content.vue'),
  },
  {
    path: '/content/:id',
    name: 'แก้ไขบทความ',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'content-writer'],
      requireAuth: true,
    },
    component: () => import('../views/content/edit-content.vue'),
  },
  {
    path: '/users-dashboard',
    name: 'User Dashboard',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'marketing'],
      requireAuth: true,
    },
    component: () => import('../views/users/users-dashboard.vue'),
  },
  {
    path: '/ads-setting/all-ads',
    name: 'All Ads',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Ads Setting',
    },
    component: () => import('../views/ads/all-ads.vue'),
  },
  {
    path: '/ads-setting/add-ads',
    name: 'Add Ads',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Ads Setting',
    },
    component: () => import('../views/ads/add-ads.vue'),
  },
  {
    path: '/ads-setting/edit-ads',
    name: 'Edit Ads Setting',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Ads Setting',
    },
    component: () => import('../views/ads/edit-ads.vue'),
  },
  {
    path: '/ads-setting/ads-report',
    name: 'Ads Report',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'marketing'],
      requireAuth: true,
      aliasName: 'Ads Setting',
    },
    component: () => import('../views/ads/ads-report.vue'),
  },
  {
    path: '/ads-setting/ads-dashboard',
    name: 'Ads Dashboard',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'marketing'],
      requireAuth: true,
      aliasName: 'Ads Setting',
    },
    component: () => import('../views/ads/ads-dashboard.vue'),
  },
  {
    path: '/promotions/all-promotion',
    name: 'All Promotions',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Promotion setting',
    },
    component: () => import('../views/promotions/all.vue'),
  },
  {
    path: '/promotions/add',
    name: 'Add Promotion',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'New Promotion',
    },
    component: () => import('../views/promotions/add.vue'),
  },
  {
    path: '/promotions/edit/:id',
    name: 'Edit Promotion Setting',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Edit Promotion',
    },
    component: () => import('../views/promotions/edit.vue'),
  },
  {
    path: '/promotions/duplicate/:id',
    name: 'Duplicate Promotion Setting',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Edit Promotion',
    },
    component: () => import('../views/promotions/duplicate.vue'),
  },
  {
    path: '/stock-checking',
    name: 'Stock Checking',
    meta: {
      allowRoles: ['owner', 'tester', 'admin', 'tester-internal', 'marketing'],
      requireAuth: true,
      aliasName: 'Stock Checking',
    },
    component: () => import('../views/stock-checking/stock-checking.vue'),
  },
  {
    path: '/feedback/general',
    name: 'Feedback',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'General Feedback',
    },
    component: () => import('../views/feedback/general.vue'),
  },
  {
    path: '/feedback/monthly-horoscope',
    name: 'Monthly horoscope',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
    },
    component: () => import('../views/feedback/monthly-horoscope.vue'),
  },
  {
    path: '/feedback/profile',
    name: 'Profile',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
    },
    component: () => import('../views/feedback/profile.vue'),
  },
  {
    path: '/feedback/day-master',
    name: 'Day Master',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
    },
    component: () => import('../views/feedback/day-master.vue'),
  },
  {
    path: '/feedback/birth-element',
    name: 'Birth Element',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
    },
    component: () => import('../views/feedback/birth-element.vue'),
  },
  {
    path: '/feedback/compatibility',
    name: 'Compatibility',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
    },
    component: () => import('../views/feedback/compatibility.vue'),
  },
  {
    path: '/feedback/daily-luck',
    name: 'Habit Forming',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
    },
    component: () => import('../views/feedback/daily-luck.vue'),
  },
  {
    path: '/feedback/ai-feedback',
    name: 'Ai Tab Feedback',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Feedback',
    },
    component: () => import('../views/feedback/ai-feedback.vue'),
  },
  {
    path: '/feedback/ai-message-feedback',
    name: 'AI Chat Feedback',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'AI Chat Feedback',
    },
    component: () => import('../views/feedback/ai-message-feedback.vue'),
  },
  {
    path: '/feedback/cancellation',
    name: 'Cancellation Feedback',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Cancellation Feedback',
    },
    component: () => import('../views/feedback/cancellation.vue'),
  },
  {
    path: '/feedback/ai-free-flow',
    name: '',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Feedback',
    },
    component: () => import('../views/feedback/ai-free-flow.vue'),
  },
  {
    path: '/ai-setting/ai/ai-dashboard',
    name: 'AI Feedback',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'AI Feedback',
    },
    component: () => import('../views/ai-settings/ai-dashboard.vue'),
  },
  {
    path: '/ai-setting/ai/conversation/:id',
    name: 'Ai Conversation List',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Feedback',
    },
    component: () => import('../views/ai-settings/ai-conversation-list.vue'),
  },
  {
    path: '/ai-setting/ai/:chatid/convesation/:conversationid',
    name: 'Ai Chat',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'Feedback',
    },
    component: () => import('../views/ai-settings/ai-conversation-history.vue'),
  },
  {
    path: '/ai-setting/questions',
    name: 'AI Setting Questions',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'AI Setting',
    },
    component: () => import('../views/ai-settings/questions.vue'),
  },
  {
    path: '/ai-setting/report/ranking',
    name: 'AI Ranking Questions',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'AI Setting',
    },
    component: () => import('../views/ai-settings/ranking.vue'),
  },
  {
    path: '/ai-setting/report',
    name: 'AI Setting Question Report',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'AI Setting',
    },
    component: () => import('../views/ai-settings/report.vue'),
  },
  {
    path: '/ai-setting/create',
    name: 'AI Setting Create Question',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'AI Setting',
    },
    component: () => import('../views/ai-settings/create.vue'),
  },
  {
    path: '/ai-setting/report/view/:id',
    name: 'AI Setting View Report By ID',
    meta: {
      allowRoles: ['owner', 'admin', 'tester-internal', 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'AI Setting',
    },
    component: () => import('../views/ai-settings/view.vue'),
  },
  {
    path: '/ai-setting/reorder',
    name: 'AI Setting Reorder Question',
    meta: {
      allowRoles: ['owner', 'admin', , 'tester', 'marketing'],
      requireAuth: true,
      aliasName: 'AI Setting',
    },
    component: () => import('../views/ai-settings/reorder.vue'),
  },
  {
    path: '/notifications/report',
    name: 'Notification Report',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
    },
    component: () => import('../views/notifications/notifications.vue'),
  },
  {
    path: '/notifications/report/:id',
    name: 'Notifications Detail',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
      aliasName: 'Notification Report',
    },
    component: () => import('../views/notifications/notification-details.vue'),
  },
  {
    path: '/notifications/manual',
    name: 'Notification Setting',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
      aliasName: 'Notification Setting',
    },
    component: () => import('../views/notifications/manual-notifications.vue'),
  },
  {
    path: '/notifications/auto',
    name: 'All Auto Notifications',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
      aliasName: 'Notification Setting',
    },
    component: () => import('../views/notifications/auto-notifications.vue'),
  },
  {
    path: '/notifications/manual/:id',
    name: 'All Manual Notifications',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
      aliasName: 'Manual Notification detail',
    },
    component: () =>
      import('../views/notifications/manual-notifications-details.vue'),
  },
  {
    path: '/notifications/auto/:id',
    name: 'Auto Manual Notifications',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
      aliasName: 'Auto Notification detail',
    },
    component: () =>
      import('../views/notifications/auto-notifications-details.vue'),
  },
  {
    path: '/notifications/form',
    name: 'Add Manual Notification',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
      aliasName: 'Notification Form',
    },
    component: () =>
      import('../views/notifications/manual-notifications-form.vue'),
  },
  {
    path: '/notifications/edit-form/:id',
    name: 'Edits Manual Notification',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
      aliasName: 'Notifications Edit Form',
    },
    component: () =>
      import('../views/notifications/manual-notifications-edit-form.vue'),
  },
  {
    path: '/notifications/copy-form/:id',
    name: 'Copy Manual Notification',
    meta: {
      allowRoles: ['owner', 'admin', , 'marketing'],
      requireAuth: true,
      aliasName: 'Notifications Copy Form',
    },
    component: () =>
      import('../views/notifications/manual-notifications-copy-form.vue'),
  },
]

const router = new VueRouter({
  routes,
})

export const allowRoutes = {
  owner: {
    defaultRedirectPath: '/fortune-telling',
  },
  'content-writer': {
    defaultRedirectPath: '/content',
  },
  admin: {
    defaultRedirectPath: '/users',
  },
  tester: {
    defaultRedirectPath: '/auspicious2',
  },
  'date-selector': {
    defaultRedirectPath: '/auspicious2',
  },
  marketing: {
    defaultRedirectPath: '/users-dashboard',
  },
  'tester-internal': {
    defaultRedirectPath: '/users-dashboard',
  },
}

router.beforeEach(async (to, from, next) => {
  let { status } = await store.dispatch('checkCredential')
  if (status == 'error' && to.name == 'signin') {
    next()
  } else {
    if (status == 'success') {
      if (!isInitialize) await store.dispatch('initializeUserFromLocalStorage')
      let { isInitialize, userRole: role } = store.getters
      let roleDefaultRedirectPath = allowRoutes[role].defaultRedirectPath

      // let roleAllowRoutes = allowRoutes[role].allow;
      // if (!roleAllowRoutes.includes(to.name)) {
      if (to.meta.requireAuth && !to.meta.allowRoles.includes(role)) {
        next(roleDefaultRedirectPath)
      } else {
        if (to.name == 'signin') {
          next(roleDefaultRedirectPath)
        } else {
          next()
        }
      }
    } else {
      next('/signin')
    }
  }
})
export default router
